if (!customElements.get('card-product')) {
  class CardProduct extends HTMLElement {
    constructor() {
      super();

      this.quickviewModalsHTML = {};
      this.variants = JSON.parse(
        this.querySelector('[type="application/json"][data-variants]')
          .textContent
      );
      this.cartDrawer = document.querySelector('cart-drawer');
      this.variantsImages = JSON.parse(
        this.querySelector('[type="application/json"][data-variants-images]')
          .textContent
      );
      this.swatches = this.querySelectorAll('[data-swatch]');

      this.swatches.forEach((swatch) => {
        swatch.addEventListener('change', this.onSwatchChange.bind(this));
      });
      this.activeVariant = this.variants?.find(
        (variant) => variant.id === Number(this.dataset.activeVariantId)
      );
    }

    connectedCallback() {
      this.form = this.querySelector('.card-product__actions-add form');
      this.submitButton = this.form?.querySelector('button[type="submit"]');
      this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    cartSubmitHandler() {
      this.submitButton.classList.add('is-loading');
      const sectionsToRender = [
        {
          id: '#cart-counter',
          section: 'cart-counter',
          selector: '#shopify-section-cart-counter',
        },
        {
          id: '#main-cart',
          section: 'main-cart',
          selector: '#main-cart',
        },
      ];

      addToCart(
        this.form,
        sectionsToRender.map((section) => section.section)
      )
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.handleErrorMessage();

          if (this.isQuickviewSelector) {
            const quickviewModal = this.closest('modal-dialog');
            quickviewModal.hide();
          }

          if (window.location.pathname !== routes.cart_url) {
            window.location.href = routes.cart_url;
            return;
          }

          if (!response?.sections['main-cart']) {
            location.reload();
          }
          sectionsToRender.map((section) => {
            const sectionToGet = section.section;
            if (!response?.sections[sectionToGet]) return;

            const source = new DOMParser().parseFromString(
              response.sections[sectionToGet],
              'text/html'
            );

            if (!source) return;

            const target = source.querySelector(section.selector);
            const destination = document.querySelector(section.id);

            if (!target || !destination) return;

            destination.innerHTML = target.innerHTML;
          });

          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.submitButton.classList.remove('is-loading');
        });
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;
      errorWrapper.classList.toggle('hidden', !errorMessage);
      errorWrapper.textContent = errorMessage || '';
    }

    defaultSubmitHandler() {
      this.submitButton.classList.add('is-loading');

      addToCart(
        this.form,
        this.cartDrawer.getSectionsToRender().map((section) => section.section)
      )
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.handleErrorMessage();

          if (this.isQuickviewSelector) {
            const quickviewModal = this.closest('modal-dialog');
            quickviewModal.hide();
          }
          this.cartDrawer.renderContents(response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.submitButton.classList.remove('is-loading');
        });
    }

    onSubmitHandler(event) {
      event.preventDefault();

      if (window.location.pathname == routes.cart_url || !this.cartDrawer)
        return this.cartSubmitHandler();
      if (this.cartDrawer) return this.defaultSubmitHandler();
    }

    onSwatchChange(event) {
      const activeVariant = this.variants.find(
        (variant) =>
          variant[`option${this.dataset.swatchOptionIndex}`] ===
          event.target.value
      );
      this.activeVariant = activeVariant;
      this.updateAssets(activeVariant);

      // Handle ATC form updates
      if (this.form) {
        this.form
          .querySelector('[name="id"]')
          ?.setAttribute('value', this.activeVariant.id);

        if (!this.submitButton) {
          return;
        }

        if (this.activeVariant.available) {
          this.submitButton.querySelector('span').textContent =
          window.variantStrings.addToCart;
          this.submitButton.removeAttribute('disabled');

          return;
        }

        this.submitButton.querySelector('span').textContent =
        window.variantStrings.soldOut;
        this.submitButton.setAttribute('disabled', 'disabled');
      }
    }

    updateAssets(activeVariant) {
      this.updateMedia(activeVariant);
      this.updateLinks(activeVariant);
    }

    updateMedia(activeVariant) {
      const media = this.querySelector('[data-media]');
      const primaryImage = this.querySelector('[data-image-primary]');
      const variantImage = this.variantsImages.find(
        (variant) => variant.id === activeVariant.id
      );

      if (!primaryImage || !variantImage) return;

      media.classList.add('is-loading');
      primaryImage.addEventListener(
        'transitionend',
        () => {
          primaryImage.src = variantImage.image.src;
          primaryImage.srcset = variantImage.image.srcset;
          primaryImage.onload = () => {
            media.classList.add('is-changed');
            media.classList.remove('is-loading');
          };
        },
        { once: true }
      );
    }

    updateLinks(activeVariant) {
      const links = this.querySelectorAll('[data-url]');

      links.forEach((link) => {
        link.setAttribute(
          link.hasAttribute('href') ? 'href' : 'data-url',
          `${this.dataset.productUrl}?variant=${activeVariant.id}`
        );
      });
    }
  }

  customElements.define('card-product', CardProduct);
}

if (!customElements.get('quickview-opener')) {
  class QuickviewOpener extends ModalOpener {
    constructor() {
      super();
    }

    onButtonClick(button) {
      const productCard = this.closest('card-product');
      const existingModal =
        productCard.quickviewModalsHTML[productCard.activeVariant.id];

      button.classList.add('is-loading');

      if (existingModal) {
        document.body.appendChild(existingModal);
        setTimeout(() => {
          super.onButtonClick(button);
          button.classList.remove('is-loading');
        }, 300);
        return;
      }

      fetch(`${button.getAttribute('data-url')}&section_id=quickview`)
        .then(response => response.text())
        .then(text => {
          const modal = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('template')
            .content.firstElementChild.cloneNode(true);
          productCard.quickviewModalsHTML[
            productCard.activeVariant.id
          ] = modal;

          // Avoid mozilla not initializing scripts
          modal.querySelectorAll('script').forEach(sciprtTag => {
            const scriptElement = document.createElement('script');
            scriptElement.src = sciprtTag.src;
            document.body.appendChild(scriptElement);
          });

          document.body.appendChild(modal);
          setTimeout(() => {
            super.onButtonClick(button);
            button.classList.remove('is-loading');
            Shopify?.PaymentButton?.init();
          }, 300);
        })
        .catch(error => console.log(error));
    }
  }

  customElements.define('quickview-opener', QuickviewOpener);
}
